
import { useState, useEffect } from 'react';
import { isSSR } from '@/lib/isSSR';

interface WindowSize {
  width: number;
  height: number;
}

export const useWindowSize = (): WindowSize => {
  // Default to conservative values when in SSR
  const defaultWidth = isSSR() ? 1024 : window.innerWidth;
  const defaultHeight = isSSR() ? 768 : window.innerHeight;
  
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: defaultWidth,
    height: defaultHeight,
  });

  useEffect(() => {
    // Skip in SSR context
    if (isSSR()) return;
    
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures effect is only run on mount and unmount

  return windowSize;
};
